const { btoa } = require('abab');

export function sleeper(ms) {
    return function(x) {
        return new Promise(resolve => setTimeout(() => resolve(x), ms));
    };
}

export function delay(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

/**
 * Encodes string to base64
 * @return {string}
 */
export function base64encode(input) {
    return btoa(unescape(encodeURIComponent(input)));
}

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

/**
 * First-touch attribution written by scrapingant.com/js/first-traffic-source.js
 * (cookie sa_first_touch on .scrapingant.com). Returns null when absent.
 */
export function getFirstTouch() {
    const raw = getCookie("sa_first_touch");
    if (!raw) return null;
    try {
        return JSON.parse(decodeURIComponent(raw));
    } catch (e) {
        return null;
    }
}

/**
 * GA4 event parameters that tie an activation event (sign_up, email_confirmed,
 * execute_request) back to the page and source that first brought the user,
 * regardless of how many sessions passed in between.
 */
export function firstTouchParams() {
    const ft = getFirstTouch();
    if (!ft) {
        return { first_source: getCookie("user_source") || "direct" };
    }
    return {
        first_landing_page: ft.lp || "",
        first_referrer: ft.ref || "",
        first_source: ft.src || "",
        first_medium: ft.med || "",
        first_campaign: ft.cmp || "",
        first_touch_date: ft.ts || "",
    };
}

export function setCookie(name, value, days, domain) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    const dom = domain ? `; domain=${domain}` : "";
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/${dom}; Secure; SameSite=Lax`;
}

export function deleteCookie(name, domain) {
    const dom = domain ? `; domain=${domain}` : "";
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${dom}`;
}
